import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Button,
  ModalBody,
  Form,
  FormGroup,
  Input,
  CustomInput,
  Label,
  FormText
} from "reactstrap";
import rest from '../../../lib/rest'
import NumberFormat from 'react-number-format'
import rotas from '../../../services/rotas'
import useForm from "../../../lib/useForm"
import ReactSelect from "../../../components/Form/Select/Select"
import Loading from 'lib/loading'
import './style.css'

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const formSwal = withReactContent(Swal)

const FromFornecedor = ({ fechaModal, filial_id, fornecedor_id}) => {

  //valores iniciais do formulario
  const inicialForm = {
    fornecedor_id: '',
    fornecedor: '',
    forn_laboratorio: '',
    forn_distribuidora: '',
    forn_cnpj: '',
    forn_inscrestadual: '',
    forn_cep: '',
    forn_endereco: '',
    forn_ender_num: '',
    forn_bairro: '',
    forn_cidade: '',
    forn_uf: '',
    forn_contato: '',
    forn_telefone: '',
    forn_fax: '',
    forn_celular: '',
    forn_email: '',
    desconto_maximo: '',
    padrao_comissao_id: '',
    padrao_comissao: '',
    comissaoSelect: '',
    filial_id: filial_id
  }

  const [form, onChange, setForm, onChangeSelect,onChangeDate, onChangeCustom] = useForm(inicialForm)
  const [listaComissao, setListaComissao]         = useState([]);
  const [loading, setLoading]                     = useState(true);
  const [refresh, setRefresh]                     = useState(0);

  // Lista comissao select
  const listaComissoes = () => {
    let comissoes = []
    try{
      const retorno = rest.get(rotas.comissao)
      retorno.then(ret => {
        if (ret.success && ret.success == 'S' && ret.lista != ''){
          comissoes = ret.lista
          for (let i = 0; i < comissoes.length; i++) {
            comissoes[i].id     = comissoes[i].padrao_comissao_id
            comissoes[i].title  = comissoes[i].padrao_comissao + ' %'
          }
          setListaComissao(comissoes)
        }
      })
      return (true)
    }catch(err){
      return (false)
    }
  }

  //preenche setform e formulario
  const editFornecedor = (filial_id, fornecedor_id) => {
    const retorno = rest.get(rotas.fornecedor+filial_id+'/'+fornecedor_id)
    retorno.then(ret => {
      if (ret.success && ret.success == 'S') {
        // ret.lista[0].comissaoSelect = {"id":ret.lista[0].padrao_comissao_id, "title":ret.lista[0].padrao_comissao + '%'}
        ret.lista[0].comissaoSelect = {"id":ret.lista[0].padrao_comissao_id, "title":ret.lista[0].padrao_comissao ? ret.lista[0].padrao_comissao+" %" : ''}
        
        if(ret.lista[0].desconto_maximo == ''){
          ret.lista[0].desconto_maximo = '0.00'
        }

        setForm(ret.lista[0])
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    if (listaComissoes()) {
      if(fornecedor_id != ''){
        editFornecedor(filial_id, fornecedor_id)
      }else{
        setForm(inicialForm)
        setLoading(false)
      }
    }
  },[])

  const bucarCadastro = (e) =>{

    const cnpj = e.target.value;

    if (form.fornecedor_id == '' && cnpj !== '') {
      let dados = {"funcao":'infoFornecedor', "cnpj": cnpj}
      const retorno = rest.post(rotas.buscaCadastro, dados);
      retorno.then(ret=>{
        if (ret.erro && ret.erro == 'N') {
          let busca = ret.lista
          form.forn_bairro        = busca.bairro.toUpperCase();
          form.forn_cep           = busca.cep.toUpperCase();
          form.forn_cidade        = busca.cidade.toUpperCase();
          form.fornecedor         = busca.fornecedor.toUpperCase();
          form.forn_inscrestadual = busca.ie.toUpperCase();
          form.forn_endereco      = busca.logradouro.toUpperCase();
          form.forn_ender_num     = busca.numero.toUpperCase();
          form.forn_uf            = busca.uf.toUpperCase();
          setRefresh(refresh + 1)
        }
      })
    }
  }

  const validaCampo = ()=>{
    if(form.fornecedor === ''){
      return false
    }

    if(form.forn_cnpj === ''){
      return false
    }

    if(form.forn_inscrestadual === ''){
      return false
    }

    if(form.forn_endereco === ''){
      return false
    }

    if(form.forn_ender_num === ''){
      return false
    }

    if(form.forn_bairro === ''){
      return false
    }

    if(form.forn_cidade === ''){
      return false
    }

    if(form.forn_uf === ''){
      return false
    }

    if(form.forn_cep === ''){
      return false
    }

    if(form.desconto_maximo === ''){
      return false
    }

    if(form.comissaoSelect === '' || !form.comissaoSelect.id || form.comissaoSelect.id === ''){
      return false
    }

    return(true);
  }

  //SUBMIT
  const handleSubmit = (evt) => {

    evt.preventDefault()

    if(validaCampo() === false){
      Swal.fire(
        'Atenção',
        'Campos obrigatórios não preenchidos!',
        'warning'
      )
      return
    }

    formSwal.queue([{
      title: 'Deseja salvar ?',
      confirmButtonText: 'Salvar',
      showCancelButton: true,
      text:'Essas informações serão salvas no banco',
      showLoaderOnConfirm: true,
      cancelButtonColor: '#d33',
      preConfirm: () => {
        const url = rotas.fornecedor+'gravar.php'
        if(fornecedor_id !== ''){
          return rest.post(url, form)
            .then(ret => {
            if (ret.success == 'S') {
              if((form.atualizar_desconto_maximo == 'S')||(form.atualizar_padrao_comissao == 'S')){
                if(ret.retorno_produtos == 'Sucesso'){
                  formSwal.fire('Salvo!',
                              ret.msg,
                              'success')
                }else{
                  formSwal.fire('Atenção',
                              'Problemas na atualização do desconto máximo / padrão comissão',
                              'warning')
                }
              }else{
                formSwal.fire('Salvo!',
                              ret.msg,
                              'success')
              }
            }else{
              formSwal.fire('Erro!',
                            ret.msg,
                            'error')
            }
          })
        }else{
          return rest.put(url, form)
            .then(ret => {
            if (ret.success == 'S') {
              formSwal.fire('Salvo!',
                            ret.msg,
                            'success')
            }else{
              formSwal.fire('Erro!',
                            ret.msg,
                            'error')
            }
          })
        }
      }
    }])
  }

  const validaCNPJMask = (value) =>{

    if(value.length > 14){
      value = value.substring(0,14);
    }
    
    if(value.length < 11){
      return(value)
    }
    
    if(value.length === 11){
      value=value.replace(/\D/g,"")
      value=value.replace(/(\d{3})(\d)/,"$1.$2")
      value=value.replace(/(\d{3})(\d)/,"$1.$2")
      value=value.replace(/(\d{3})(\d{1,2})$/,"$1-$2")
      return(value)
    }

    if(value.length > 11){
      value=value.replace(/\D/g,"")
      value=value.replace(/(\d{2})(\d)/,"$1.$2")
      value=value.replace(/(\d{3})(\d)/,"$1.$2")
      value=value.replace(/(\d{3})(\d)/,"$1/$2")
      value=value.replace(/(\d{4})(\d{1,2})$/,"$1-$2")
      return(value)
    }
  }

  const verificaDescontoMaximo = ()=>{
    if(form.desconto_maximo != ""){
      Swal.fire({
        title: 'Gostaria de atribuir o desconto máximo aos produtos cadastrados para este fabricante?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Sim',
        denyButtonText: 'Não',
      }).then((result) => {
        if (result.isConfirmed) {
          form.atualizar_desconto_maximo = 'S';
        } else {
          form.atualizar_desconto_maximo = 'N';
        }
      })
    }
  }

  const verificaPadraoComissao = ()=>{
    Swal.fire({
      title: 'Gostaria de atribuir esse padrão de comissão aos produtos cadastrados para este fabricante?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sim',
      denyButtonText: 'Não',
    }).then((result) => {
      if (result.isConfirmed) {
        form.atualizar_padrao_comissao = 'S';
      } else {
        form.atualizar_padrao_comissao = 'N';
      }
    })
  }

  const consultaCEP = (e) =>{
    const cep = e.target.value;

    if (cep !== '' && cep.length == 8) {
      // const retorno = rest.get("https://www.digifarma.com.br/webservice/cep/cep.php?cep=" + cep);
      const retorno = rest.get(rotas.consultaCep + '?cep=' + cep);
      retorno.then(ret=>{
        if(!ret.erro){
          form.forn_endereco  = (ret.logradouro !== '') ? ret.logradouro.toUpperCase():form.forn_endereco;
          form.forn_bairro    = (ret.bairro !== '') ? ret.bairro.toUpperCase(): form.forn_bairro;
          form.forn_cidade    = ret.localidade.toUpperCase();
          form.forn_uf        = ret.uf.toUpperCase();
          setRefresh(refresh + 1)
        }
      })
    }
  }

  if (loading) {
    return (
      <ModalBody className ="loadingBody">
        <Loading tipo='componente'/>
      </ModalBody>
    )
  }else {
    return (
      <>
      <FormGroup className="formCadastro">
        <ModalBody className="pb-0">
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md='4'>
                <FormGroup>
                  <Label for="fornecedor_id">Código</Label>
                  <Input
                    disabled
                    style={{background: '#F9F9F9'}}
                    name     = "fornecedor_id"
                    id       = "fornecedor_id"
                    value    = {form.fornecedor_id}
                    onChange = {onChange('fornecedor_id')}
                  />
                </FormGroup>
              </Col>

              <Col md='4' className="card-2" style={{padding: '10px'}}>
                <FormGroup className="mb-0">
                  <span className="tag-card">Tipo</span>
                  <Row >
                    <CustomInput
                      className = "radioRep ml-3"
                      type      = "radio"
                      id        = "forn_laboratorio"
                      name      = "forn_laboratorio"
                      value     = "S"
                      label     = "Laboratório"
                      checked   = {form.forn_laboratorio=='S' ? true : false}
                      // onClick   = {onChange('forn_laboratorio')}onChangeCustom
                      // onChange  = {onChange('forn_laboratorio')}
                      onClick   = {onChangeCustom('forn_laboratorio', 'forn_distribuidora')}
                      onChange  = {onChangeCustom('forn_laboratorio', 'forn_distribuidora')}
                    />
                    <CustomInput
                      className = "radioRep ml-3"
                      type      = "radio"
                      id        = "forn_distribuidora"
                      name      = "forn_distribuidora"
                      value     = "S"
                      label     = "Distribuidora"
                      checked   = {form.forn_distribuidora=='S' ? true : false}
                      // onClick   = {onChange('forn_distribuidora')}
                      // onChange  = {onChange('forn_distribuidora')}
                      onClick   = {onChangeCustom('forn_distribuidora', 'forn_laboratorio')}
                      onChange  = {onChangeCustom('forn_distribuidora', 'forn_laboratorio')}
                    />
                  </Row>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md='6'>
                <FormGroup>
                  <Label for="categoria">Fornecedor</Label>
                  <Input
                    required
                    name     = "categoria"
                    id       = "categoria"
                    value    = {form.fornecedor}
                    onChange = {onChange('fornecedor')}
                    invalid = {form.fornecedor === '' ? true : false}
                  />
                </FormGroup>
              </Col>

              <Col md='3'>
                <FormGroup>
                  <Label for="cnpj">cnpj</Label>
                  <NumberFormat
                    // valid
                    className = {form.forn_cnpj.length < 11 ? "form-control number-format-invalid is-invalid" : "form-control"} 
                    format={validaCNPJMask}
                    // format    = "##.###.###/####-##"
                    name      = "cnpj"
                    id        = "cnpj"
                    value     = {form.forn_cnpj}
                    onChange  = {onChange('forn_cnpj')}
                    onBlur    = {bucarCadastro}
                  />
                </FormGroup>
              </Col>

              <Col md='3'>
                <FormGroup>
                  <Label for="forn_inscrestadual">Inscr. Estadual</Label>
                  <Input
                    name     = "forn_inscrestadual"
                    id       = "forn_inscrestadual"
                    value    = {form.forn_inscrestadual}
                    onChange = {onChange('forn_inscrestadual')}
                    invalid = {form.forn_inscrestadual === '' ? true : false}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md='3'>
                <FormGroup>
                  <Label for="cep">Cep</Label>
                  <Input
                    name      = "cep"
                    id        = "cep"
                    value     = {form.forn_cep}
                    onChange  = {onChange('forn_cep')}
                    invalid   = {form.forn_cep === '' ? true : false}
                    onBlur    = {consultaCEP}
                  />
                </FormGroup>
              </Col>

              <Col md='6'>
                <FormGroup>
                  <Label for="endereco">Endereço</Label>
                  <Input
                    name     = "endereco"
                    id       = "endereco"
                    value    = {form.forn_endereco}
                    onChange = {onChange('forn_endereco')}
                    invalid = {form.forn_endereco === '' ? true : false}
                  />
                </FormGroup>
              </Col>

              <Col md='3'>
                <FormGroup>
                  <Label for="forn_ender_num">Número</Label>
                  <Input
                    name     = "forn_ender_num"
                    id       = "forn_ender_num"
                    value    = {form.forn_ender_num}
                    onChange = {onChange('forn_ender_num')}
                    invalid = {form.forn_ender_num === '' ? true : false}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md='3'>
                <FormGroup>
                  <Label for="forn_bairro">Bairro</Label>
                  <Input
                    name     = "forn_bairro"
                    id       = "forn_bairro"
                    value    = {form.forn_bairro}
                    onChange = {onChange('forn_bairro')}
                    invalid = {form.forn_bairro === '' ? true : false}
                  />
                </FormGroup>
              </Col>

              <Col md='6'>
                <FormGroup>
                  <Label for="forn_cidade">Cidade</Label>
                  <Input
                    name     = "forn_cidade"
                    id       = "forn_cidade"
                    value    = {form.forn_cidade}
                    onChange = {onChange('forn_cidade')}
                    invalid = {form.forn_cidade === '' ? true : false}
                  />
                </FormGroup>
              </Col>

              <Col md='3'>
                <FormGroup>
                  <Label for="uf">Uf</Label>
                  <Input
                    required
                    name      = "uf"
                    id        = "uf"
                    value     = {form.forn_uf}
                    onChange  = {onChange('forn_uf')}
                    invalid = {form.forn_uf === '' ? true : false}
                    maxLength = {2}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md='3'>
                <FormGroup>
                  <Label for="forn_contato">Contato</Label>
                  <Input
                    name      = "forn_contato"
                    id        = "forn_contato"
                    value     = {form.forn_contato}
                    onChange  = {onChange('forn_contato')}
                  />
                </FormGroup>
              </Col>

              <Col md='3'>
                <FormGroup>
                  <Label for="forn_telefone">Telefone</Label>
                  <NumberFormat
                    // valid
                    className = "form-control"
                    format    = "(##)####-####"
                    name      = "forn_telefone"
                    id        = "forn_telefone"
                    value     = {form.forn_telefone}
                    onChange  = {onChange('forn_telefone')}
                  />
                </FormGroup>
              </Col>

              <Col md='3'>
                <FormGroup>
                  <Label for="forn_fax">Fax</Label>
                  <NumberFormat
                    // valid
                    className = "form-control"
                    format    = "(##)####-####"
                    name      = "forn_fax"
                    id        = "forn_fax"
                    value     = {form.forn_fax}
                    onChange  = {onChange('forn_fax')}
                  />
                </FormGroup>
              </Col>

              <Col md='3'>
                <FormGroup>
                  <Label for="forn_celular">Celular</Label>
                  <NumberFormat
                    // valid
                    className = "form-control"
                    format    = "(##)#-####-####"
                    name      = "forn_celular"
                    id        = "forn_celular"
                    value     = {form.forn_celular}
                    onChange  = {onChange('forn_celular')}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md='6'>
                <FormGroup>
                  <Label for="forn_email">E-mail</Label>
                  <Input
                    name        = "forn_email"
                    id          = "forn_email"
                    type        = "email"
                    placeholder = "exemplo email@email.com.br"
                    value       = {form.forn_email}
                    onChange    = {onChange('forn_email')}
                  />
                </FormGroup>
              </Col>

              <Col md='3'>
                <FormGroup>
                  <Label for="desconto">Desconto Máximo <span style={{ color: '#dc3545' }}>*</span></Label>
                  <NumberFormat
                    id                = "desconto"
                    name              = "desconto"
                    placeholder       = "0,00%"
                    value             = {(form.desconto_maximo || '').replace('.', ',')}
                    onChange          = {onChange('desconto_maximo')}
                    maxLength         = {20}
                    decimalScale      = {2}
                    allowNegative     = {false}
                    className         = {"form-control " + (form.desconto_maximo === '' ? 'is-invalid' : '')}
                    suffix            = {"%"}
                    decimalSeparator  = {','}
                    fixedDecimalScale
                    onBlur            ={()=>{verificaDescontoMaximo()}}
                  />
                </FormGroup>
              </Col>

              <Col md='3'>
                <FormGroup>
                  <ReactSelect
                    name          = "comissao"
                    label         = "Comissão"
                    placeholder   = "Selecione"
                    options       = {listaComissao}
                    defaultValue  = {form.comissaoSelect}
                    onChange      = {onChangeSelect('comissaoSelect')}
                    onBlur        = {()=>{verificaPadraoComissao()}}                       
                    styles={{
                      control: (base) => ({
                        ...base,
                        border: (form.comissaoSelect == '' || (form.comissaoSelect.id == '')) ? '1px solid #dc3545' : base.border,
                        height: '100%',
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                    }}
                    menuPortalTarget={document.body}
                  >
                  </ReactSelect>
                </FormGroup>
              </Col>
            </Row>

            <Col className="text-center p-3">
              <Button type="submit" className="mb-0 mt-0" color="success" size="md" >Salvar</Button>
              <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={() => fechaModal()}>Fechar</Button>
            </Col>
          </Form>
        </ModalBody>
      </FormGroup>
      </>
    )
  }

}

export default FromFornecedor
